import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { categorySelector,subCategorySelector } from 'redux/selectors/category.selector';
import { scrollTop } from 'helpers/window';
import {
  categoriesArrayPropTypes, categoryPropTypes, productsArrayPropTypes,
} from 'helpers/propTypes';

import ItemContainer from 'containers/ItemContainer';
import Products from 'views/Products';
import ProductsTextil from 'views/Products/ProductsTextil';

const limit = 40;

const PaginatorContainer = (props) => {
  const {
    category, categories, loading, maxPrice, minimumPurchase, name, products, url,
    subCategories, client, subcategory,
  } = props;
  const [itemsFiltered, setItemsFiltered] = useState([]);
  const priceRange = [0, Math.ceil(maxPrice)];
  const [inputRangeValue, setInputRangeValue] = useState(priceRange);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [checked, setChecked] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [orderProducts, setOrderProducts] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const activeSubcategory = selectedSubcategory || subcategory;

  const subCategoriesFiltered = !!category ? subCategories.filter(subcat => subcat.category_id === category.id) : [];

  const cantMedidasMax = Math.max(
    ...items.map(item => {
      const descripcionesFiltradas = item.stock_product_descriptions?.filter(
        desc => desc.stock_descriptions?.stock_category_id === 2
      ) || [];
  
      const nombres = descripcionesFiltradas.map(desc => desc.stock_descriptions?.name);
      const nombresUnicos = new Set(nombres);
  
      const incluyeUno = nombresUnicos.has('1') || nombresUnicos.has(1);
  
      return nombresUnicos.size - (incluyeUno ? 1 : 0);
    })
  );  

  const setCurrentPage = (currentPage, currentItems) => {
    const totalItems = Math.ceil(currentItems.length / limit);
    const offset = Math.ceil((currentPage - 1) * limit);
    const itemsPaginated = currentItems.slice(offset, offset + limit);
    scrollTop();
    setPage(currentPage);
    setTotal(totalItems);
    setItems(itemsPaginated);
  };

  const orderFilteredProducts = (productsToFilter) => {
    if (orderProducts) {
      switch (orderProducts.value) {
        case 'A-Z':
          productsToFilter.sort((product, otherProduct) => {
            const fa = product.name.toLowerCase();
            const fb = otherProduct.name.toLowerCase();
            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
          return productsToFilter;
        case 'Z-A':
          productsToFilter.sort((product, otherProduct) => {
            const fa = product.name.toLowerCase();
            const fb = otherProduct.name.toLowerCase();
            if (fa > fb) {
              return -1;
            }
            if (fa < fb) {
              return 1;
            }
            return 0;
          });
          return productsToFilter;
        case 'ascendente':
          productsToFilter.sort((product, otherProduct) => product.price - otherProduct.price);
          return productsToFilter;
        case 'descendente':
          productsToFilter.sort((product, otherProduct) => otherProduct.price - product.price);
          return productsToFilter;
        default:
          return productsToFilter;
      }
    }
    return productsToFilter;
  };

  const filterByPrice = (product) => {
    const min = inputRangeValue[0];
    const max = inputRangeValue[1] === 0 ? Math.ceil(maxPrice) : inputRangeValue[1];
    return product.sale
      ? product.sale >= min && product.sale <= max
      : product.price >= min && product.price <= max;
  };

  const filterBySale = (product) => (
    checked
      ? product.sale > 0
      : true);

  const filterByCategories = (product) => (
    !category || product.categories.some((cat) => cat.code === category.code)
  );

  const filterBySubCategories = (product) => (
    !activeSubcategory ||
    product.sub_categories.some((cat) => cat.code === activeSubcategory.code)  );

  const filterItems = () => {
    const filtered = products.filter((product) => (
      filterByPrice(product)
      && filterByCategories(product)
      && filterBySale(product)
      && filterBySubCategories(product)
    ));
    const productsFiltered = orderFilteredProducts(filtered);
    setItemsFiltered(productsFiltered);
    setCurrentPage(1, productsFiltered);
  };

  useEffect(() => {

    if (products.length >= 0 && maxPrice !== 0) {
      filterItems();
      setProductsLoading(true);
    }
    // eslint-disable-next-line
  }, [category, categories, loading, maxPrice, products, subcategory, selectedSubcategory]);

  const handleSubCategory = (subcat) => {
    setSelectedSubcategory(subcat || null);
  };

  useEffect(() => {
    setSelectedSubcategory(null);
  }, [category?.id]);

  const handlePaginationChange = (event, currentPage) => {
    setCurrentPage(currentPage, itemsFiltered);
  };

  const handleInputRangeChange = (event, value) => {
    setInputRangeValue(value);
  };

  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const design = client?.design ?? 0;

  let suffix;
  switch (design) {
    case 0:
      suffix = '-simple';
      break;
    case 2:
      suffix = '-sandy';
      break;
    case 1:
    default:
      suffix = '-simple';
  }
  const renderItem = (item) => {
    switch (client?.design) {
      case 3:
        return (
          <div className="col-product-textil" style={{ background: 'rgb(249 249 249)', borderRadius: '16px' }} key={`item-${item.id}`}>
            <ItemContainer item={item} cantMedidasMax={cantMedidasMax} />
          </div>
        );
        case 4:
         suffix = '-neo';
      default:
        return (
        <div className={`margin-product col-products${suffix}`} 
        style={{background: client?.design !== 2 ? 'rgb(249, 249, 249)' : '' , borderRadius: '16px' }}
        key={`item-${item.id}`}>
          <ItemContainer item={item} />
        </div>
        );
    }
  };

  switch(design){
    case 3:
      return (
        <ProductsTextil
        category={category}
        categories={categories}
        checked={checked}
        filterItems={filterItems}
        handleCheckboxChange={handleCheckboxChange}
        handleInputRangeChange={handleInputRangeChange}
        handlePaginationChange={handlePaginationChange}
        handleSubCategory={handleSubCategory}
        inputRangeValue={inputRangeValue}
        items={items}
        loading={loading}
        maxPrice={maxPrice}
        minimumPurchase={minimumPurchase}
        name={name}
        orderProducts={orderProducts}
        page={page}
        productsLoading={productsLoading}
        renderItem={renderItem}
        setOrderProducts={setOrderProducts}
        subCategories={subCategoriesFiltered}
        subCategory={activeSubcategory}
        total={total}
        url={url}
        client={client}
      />);
    default:
      return (
        <Products
          category={category}
          categories={categories}
          filterItems={filterItems}
          handleSubCategory={handleSubCategory}
          handleInputRangeChange={handleInputRangeChange}
          handlePaginationChange={handlePaginationChange}
          inputRangeValue={inputRangeValue}
          checked={checked}
          handleCheckboxChange={handleCheckboxChange}
          setOrderProducts={setOrderProducts}
          orderProducts={orderProducts}
          items={items}
          loading={loading}
          maxPrice={maxPrice}
          minimumPurchase={minimumPurchase}
          name={name}
          page={page}
          renderItem={renderItem}
          productsLoading={productsLoading}
          subCategories={subCategoriesFiltered}
          subCategory={activeSubcategory}
          total={total}
          url={url}
          client={client}
        />
      );
  };
};

const mapStateToProps = (state, props) => ({
  category: categorySelector(state, props),
  categories: state.category.items,
  loading: state.product.loading,
  maxPrice: state.product.maxPrice,
  minimumPurchase: state.app.minimumPurchase,
  subcategory: subCategorySelector(state, props),
  subCategories: state.subCategory.items,
  client: state.app.client,
});

PaginatorContainer.defaultProps = {
  category: null,
};

PaginatorContainer.propTypes = {
  category: categoryPropTypes,
  categories: categoriesArrayPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  maxPrice: PropTypes.number.isRequired,
  minimumPurchase: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  products: productsArrayPropTypes.isRequired,
  url: PropTypes.string.isRequired,
  subCategories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default connect(mapStateToProps)(PaginatorContainer);
